import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';

import {ModalDirective} from 'ng2-bootstrap';

import {Event, EventId} from '../../../models/base/event';
import {WebMethodResult} from '../../../models/web-method-result';
import {Company} from '../../../models/lookups/company';
import {Stockroom} from '../../../models/stockroom/stockroom';
import {ClientSettingsService} from '../../../services/settings/client-settings.service';
import {SecurityService} from '../../../services/settings/security.service';

import {BaseComponent} from '../../base/base.component';
import {AppModulePath} from 'app/models/app-module-path';
import {HomeComponent} from 'app/components/home/home.component';
import {isNil} from 'lodash';
import {TranslateService} from '@ngx-translate/core';
import {MenuItem} from 'primeng';

@Component({
  selector: 'bms-home-nabavke',
  templateUrl: './home-nabavke.component.html',
  styleUrls: ['./home-nabavke.component.scss']
})
export class HomeNabavkeComponent extends BaseComponent implements OnInit {

  activeUserId: number;
  activeCompany: Company;
  activeStockroom: Stockroom;
  afterLogin: boolean;
  username: string;
  showCalendar: boolean;
  appModulePath: typeof AppModulePath;

  @ViewChild('chooseCSDialog', {static: false})
  chooseCSDialog: ModalDirective;

  menuItems: MenuItem[] = [];

  constructor(private clientSettings: ClientSettingsService,
              public securityService: SecurityService,
              public router: Router,
              private location: Location) {
    super();
    this.appModulePath = AppModulePath;
    this.buildMenuItems();

    this.showCalendar = true;
    router.events.subscribe((val) => {
      // console.log(location.path());
      if (location.path() !== '/ng/nabavka') {
        this.showCalendar = false;
      } else {
        this.showCalendar = true;
      }
    });

  }

  ngOnInit() {
    this.preventClose();
    this.securityService.fetchLoggerUser().subscribe(
      data => {
        this.translateSvc.use(this.securityService.loggedUser.uiLang);
        this.buildMenuItems();
        this.username = this.securityService.loggedUser.fullName();
        this.activeUserId = this.securityService.loggedUser.id;
        this.activeCompany = this.clientSettings.getActiveCompany();
        this.activeStockroom = this.clientSettings.getActiveStockroom();

        if ((!isNil(this.activeCompany) && isNil(this.activeCompany.id)) ||
          (!isNil(this.activeStockroom) && isNil(this.activeStockroom.id))) {
          this.afterLogin = true;
          if (!isNil(this.chooseCSDialog)) {
            this.chooseCSDialog.show();
          }
        } else {
          this.clientSettings.setActiveCompany(this.activeCompany);
          this.clientSettings.setActiveStockroom(this.activeStockroom);

//              this.router.navigate(["ng/nabavka"]);
        }
      }
    );
  }

  showChooseCSDialog() {
    this.afterLogin = false;
    this.chooseCSDialog.show();
  }

  onEvent(event: Event) {
    if (event.id === EventId.DIALOG_OK) {
      this.activeCompany = event.object.company;
      this.activeStockroom = event.object.stockroom;

      this.clientSettings.setActiveCompany(this.activeCompany);
      this.clientSettings.setActiveStockroom(this.activeStockroom);

      if (this.afterLogin) {
        this.router.navigate(['ng/home']);
      }
    } else if (event.id === EventId.DIALOG_CANCEL && this.afterLogin) {
      this.displayErrorPage('Niste izabrali ni kompaniju ni magacin!');
      // this.router.navigate(['ng/error'], {
      //   queryParams: {
      //     errorObj: JSON.stringify(WebMethodResult.create(-1, 'Niste izabrali ni kompaniju ni magacin!'))
      //   }
      // });
    }

    this.chooseCSDialog.hide();
  }

  preventClose() {
    $('a.prevent-close').on('click', function (e) {
      $(this).next().toggle();
      e.stopPropagation();
      e.preventDefault();
    });
  }

  onLogout() {
    this.securityService.logout().subscribe(
      success => window.location.reload()
    );
  }

  private buildMenuItems(): void {
    const activeLang = this.securityService.loggedUser ? this.securityService.loggedUser.uiLang : 'sr-Latn';
    this.transl([
      'home.menu.logout',
      'home.menu.english',
      'home.menu.serbianLatin',
      'home.menu.serbianCyrillic'
    ]).subscribe(t => {
      this.menuItems = [
        {
          label: t.homeMenuLogout,
          icon: 'fa fa-sign-out',
          command: () => {
            this.onLogout();
          }
        },
        {label: '', separator: true},
        {
          label: t.homeMenuEnglish,
          styleClass: this.getLanguageMenuItemClass(activeLang, 'en'),
          command: () => {
            this.onLanguageChange('en');
          }
        },
        {
          label: t.homeMenuSerbianLatin,
          styleClass: this.getLanguageMenuItemClass(activeLang, 'sr-Latn'),
          command: () => {
            this.onLanguageChange('sr-Latn');
          }
        },
        {
          label: t.homeMenuSerbianCyrillic,
          styleClass: this.getLanguageMenuItemClass(activeLang, 'sr-Cyrl'),
          command: () => {
            this.onLanguageChange('sr-Cyrl');
          }
        }];
    });
  }

  private getLanguageMenuItemClass(activeLang: string, lang: string): string {
    return activeLang === lang ? 'user-menu-language user-menu-language-selected' : 'user-menu-language';
  }

  openAPMforUser() {
    if (!!HomeComponent.APM) {
      window.open(HomeComponent.APM + '/#/settings', '_blank');
    }
  }

  private onLanguageChange(lang: string) {
    this.securityService.loggedUser.uiLang = lang;
    this.securityService.setLang(this.securityService.loggedUser.lang).subscribe({
      next: () => {
        this.translateSvc.use(lang);
        this.buildMenuItems();
      },
      error: (err) => {
        this.setError(err);
      }
    });
  }
}
